var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72925 1.06741C8.83792 0.839673 9.16208 0.839673 9.27075 1.06741L11.378 5.48349C11.4217 5.57515 11.5089 5.63845 11.6096 5.65172L16.4607 6.29119C16.7108 6.32417 16.811 6.63247 16.628 6.8062L13.0792 10.175C13.0056 10.2449 12.9723 10.3473 12.9908 10.4472L13.8817 15.2585C13.9276 15.5066 13.6654 15.6971 13.4436 15.5767L9.1431 13.2427C9.05385 13.1942 8.94615 13.1942 8.8569 13.2427L4.55639 15.5767C4.33461 15.6971 4.07235 15.5066 4.1183 15.2585L5.0092 10.4472C5.02769 10.3473 4.99441 10.2449 4.92076 10.175L1.37199 6.8062C1.18898 6.63247 1.28915 6.32417 1.53933 6.29119L6.39045 5.65172C6.49113 5.63845 6.57826 5.57515 6.622 5.48349L8.72925 1.06741Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2eea182811ff256767fc44aa822818b7.svg";
export { ForwardRef as ReactComponent };